







































































import ExercisesFormInput from '@/components/exercises/forms/ExercisesFormInput.vue'
import ExercisesFormWithLabel, { DirectionType } from '@/components/exercises/forms/ExercisesFormWithLabel.vue'
import { withDefault } from '@/components/exercises/measure/filters'
import { getPatientName } from '@/utils/patients'

export default {
  components: {
    ExercisesFormInput,
    ExercisesFormWithLabel,
  },
  filters: {
    withDefault,
  },
  props: {
    isEditable: {
      type: Boolean,
      default: false,
    },
    exercise: {
      type: Object,
      required: true,
      validator: obj => ['id', 'pmhx', 'precautions', 'exerciseDate'].every(key => key in obj),
    },
  },
  data() {
    return {
      openMenu: false,
      DirectionType,
    }
  },
  computed: {
    patientName() {
      return getPatientName({
        id: this.exercise.patientId,
        firstName: this.exercise.patientFirstName,
        lastName: this.exercise.patientLastName,
      })
    },
  },
  methods: {
    getPatientName,
  },
}
